import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "uv-tile-description" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "divider" }, "|", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "divider" }, "|", -1)

import { computed } from 'vue'; 
	import { useStore } from 'vuex';
	import { IVehicle } from '@/types';
	
	import { commify } from '@/helpers';
import { EStockCategoryId } from '@/enums';

	
export default /*#__PURE__*/_defineComponent({
  props: {
    vehicle: null
  },
  setup(__props: any) {

const props = __props as {
		vehicle: IVehicle
	}

	
	
	const store = useStore();
	const showKms = computed(() => props.vehicle.Kms && EStockCategoryId.used == props.vehicle.StockCategoryId);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showKms))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString(_unref(commify)(__props.vehicle.Kms)) + "kms ", 1),
          _hoisted_2
        ], 64))
      : _createCommentVNode("", true),
    (__props.vehicle.Engine)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(__props.vehicle.Engine) + " ", 1),
          _hoisted_3
        ], 64))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(__props.vehicle.Transmission || ''), 1)
  ]))
}
}

})